// extracted by mini-css-extract-plugin
export default {"section":"TimerButton_section__GbjXj","label":"TimerButton_label__3e00S","playButton":"TimerButton_playButton__LcEos","pauseButton":"TimerButton_pauseButton__UdD-H"};